export const EUROPE = "europe";

// Iframe constants
export const IFRAME_HEIGHT_OFFSET = 50;
export const IFRAME_STYLE_TAG_ID = "dark-mode-injected-style";
export const IFRAME_ID = "privacy-id";
export const darkModeStyles = `
  html[data-theme="dark"] body {
    color: #a9a9a9 !important;
  }

  html[data-theme="dark"] .auto-style1 {
    color: #e5e5e5 !important;
  }

  html[data-theme="dark"] strong {
    color: #e5e5e5 !important;
  }

  html[data-theme="dark"] a {
    color: #0381fe !important;
  }

  html[data-theme="dark"] a strong {
    color: #0381fe !important;
  }
`;
